import { en } from "./en";
import { ru } from "./ru";
import { uk } from "./uk";

export const translations = {
  en,
  uk,
  ru,
};